import { isEmbroideryTrace } from "./appVariant";

/**
 * Central Firebase path/collection config per app variant.
 * SvgTrace and EmbroideryTrace use completely separate Storage folders
 * and Firestore collections so their data never mixes.
 */

// Firestore collection for file metadata (authoritative source of truth)
export const METADATA_COLLECTION = isEmbroideryTrace ? "embroiderymetadata" : "svgMetadata";

// Subcollection under accountData/{uid}/ for the user's file list cache
export const FILES_SUBCOLLECTION = isEmbroideryTrace ? "embroideryfiles" : "files";

// Firebase Storage folder for uploaded files
export const SVG_FOLDER = isEmbroideryTrace ? "embroidery" : "svg";

// Firebase Storage folder for AI-generated files
export const SVG_GENERATED_FOLDER = isEmbroideryTrace ? "embroidery_generated" : "svg_generated";

// Source bitmaps kept as non-exporting digitizing backdrops. These live beside
// the traced SVG, but never become part of an SVG or machine-stitch download.
export const REFERENCE_ARTWORK_FOLDER = isEmbroideryTrace ? "embroidery_artwork" : "svg_artwork";

// Algolia index backing the community search / creator filter. Each variant has
// its own index so the two galleries never return each other's designs.
export const ALGOLIA_INDEX = isEmbroideryTrace ? "embroideryMetadata" : "svgMetadata";

// Subfolder under Storage's public/ prefix holding published copies.
export const PUBLIC_FOLDER = isEmbroideryTrace ? "public/embroidery" : "public";
